export default {
  metaTitle: 'Kilimall E-commerce Cloud - 商品报名',
  pageTitle1: '促销活动',
  pageTitle2: '商品报名',
  pageTitle3: '活动信息摘要',
  activity1: '活动展示名',
  activity2: '促销类型',
  activity3: '满',
  activity4: '减',
  activity5: '活动起始时间',
  activity6: '至',
  activity7: '抵扣选项',
  activity8: '创建的时间',
  activity9: '报名信息',
  activity10: '请输入要报名的listingid，多个以逗号分隔',
  placeholder1: 'Please Enter Listing number',
  btn: '检测',
  btn2: '提交报名',
  signUp: '以下商品报名失败',
  signUp2: '商品ID',
  signUp3: 'Msg',
  error1: 'The product ID cannot exceed 30, the ID must be an integer, and the beginning and end cannot be commas or spaces.',
  error2: 'Please use English commas.',
  columnListing1: 'Listing ID',
  columnListing2: 'Title',
  columnListing3: 'Price Min',
  columnListing4: 'Price Max',
  columnListing5: 'Sku Count',
  columnListing6: 'Status',
  columnListing7: 'Operation',
  status1: 'Offline',
  status2: 'Online',
  remove: 'Remove',
  error5: '当前不可用',
  error6: '请先检测listing ID',
  error7: '请确保至少一个listing可用',
  error8: '请检测listing',
  content1: '确认报名吗'
}
